class RouteScreen {
  constructor({ layout, modifyResponse, preComponent }) {
    this.layout = layout
    this.modifyResponse = modifyResponse
    this.preComponent = preComponent
  }
}

export default RouteScreen
